import React, { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { Button } from "@/components/ui/button";
import { Loader2, Save } from "lucide-react";

// Types for the profile form
interface ProfileFormProps {
  profile: any;
  mentorInfo: any;
  loading: boolean;
  onSubmit: () => Promise<void>;
  children: React.ReactNode;
}

export const ProfileForm = ({
  profile,
  mentorInfo,
  loading,
  onSubmit,
  children
}: ProfileFormProps) => {
  const { toast } = useToast();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    console.log('🔄 [ProfileForm] Submit do formulário iniciado');
    
    try {
      setSaving(true);
      
      await onSubmit();
      
      toast({
        title: "Perfil salvo!",
        description: "Suas informações de perfil foram atualizadas com sucesso."
      });
    } catch (error) {
      console.error('❌ [ProfileForm] Erro no submit:', error);
      // Erro já é tratado dentro do hook useProfile
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {children}
      
      <div className="mt-6 flex justify-end">
        <Button
          type="submit"
          className="bg-[#00B6F0] hover:bg-[#0099CC] text-white"
          disabled={saving}
        >
          {saving ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Salvando...
            </>
          ) : (
            <>
              <Save className="mr-2 h-4 w-4" />
              Salvar perfil
            </>
          )}
        </Button>
      </div>
    </form>
  );
};
